module.exports = __webpack_public_path__ + "img/academy_hacks-sm.bbd23bfd.png";